export class LoginForm {
	email: string;
	password: string;
}

export class User {
	userId: number;
	firstName: string;
	lastName: string;
	name: string;
	email: string;
	roles?: Role[];
	defaults?: {
		[key: string]: any;
	};
	customerId: number;
}

export enum Role {
	SuperAdministrator = 0,
	Administrator = 1,
	Manager = 2,
	Concierge = 3,
	Provider = 4
}

export class NewUser {
	name: string;
	email: string;
	password: string;
	subscribeMe: boolean;

	token?: string;
	tokenType?: NewUserTokenType;
}

export enum NewUserTokenType {
	Rsvp = 1
}

export class ChangePassword {
	oldPassword: string;
	newPassword: string;
}

export class ForgotPassword {
	token: string;
	email: string;
	newPassword: string;
}

export class EditUser {
	firstName: string;
	lastName: string;
	defaults: {
		[key: string]: string;
	};
}
